import { Link } from "react-router-dom";
import type { CapabilityMappingLinkItem } from "../capabilityMapping";

export interface CapabilityMappingProps {
  label: string;
  items: CapabilityMappingLinkItem[];
  compact?: boolean;
}

/**
 * A linked correspondence list. The thin partner signal is redundant with the
 * visible capability name and exact fit label; it never states coverage alone.
 */
export function CapabilityMapping({ label, items, compact = false }: CapabilityMappingProps) {
  if (!items.length) return null;
  return (
    <div className={`apf-capability-mapping${compact ? " apf-capability-mapping--compact" : ""}`}>
      <p className="apf-capability-mapping__label">{label}</p>
      <ul className="apf-capability-mapping__list">
        {items.map((item) => (
          <li className="apf-capability-mapping__item" key={item.id}>
            <Link className="apf-capability-mapping__link" to={item.to}>
              <span className="apf-capability-mapping__name">{item.label}</span>
              {item.context ? <span className="apf-capability-mapping__context">{item.context}</span> : null}
              <span className="apf-capability-mapping__fit">{item.fitLabel}</span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}

